export default "__VITE_ASSET__B3y8k2Dq__"